import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from "react-router-dom";
import { ContactSection } from './ContactSection';
import MediaSection from './MediaSection';
import { AnimatePresence } from "framer-motion";
import MeditationPage from './projectPages/MeditationPage';
import MeditationApp from './apps/MeditationApp';
import DreamPage from './projectPages/DreamPage';
import EscapeVelocity from './EscapeVelocity';
import NewHeader from './NewHeader';
import SoundPage from './projectPages/SoundPage';
import NewProj from './NewProj';
import UCatPage from './projectPages/UCatPage';
import PageWrapper from './PageWrapper';
import TechGymPage from './projectPages/TechGymPage'
import { useEffect, useRef } from "react";
import RSIPage from './projectPages/RSIPage';
import NeuroPage from './projectPages/NeuroPage';
import PondererPage from './projectPages/PondererPage';
import WorkWithUsPage from './projectPages/WorkWithUsPage';
import SoWhatPage from './projectPages/SoWhatPage';

function AnimatedRoutes() {
  const location = useLocation();
  const firstLoad = useRef(true);

  useEffect(() => {
    // mark that we’ve animated once already
    if (firstLoad.current) firstLoad.current = false;
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* ✅ Only skip animation on first load */}
        <Route
          path="/"
          element={
            <PageWrapper
              direction="right"
              skip={firstLoad.current && location.pathname === "/"}
            >
              <MainPage />
            </PageWrapper>
          }
        />
        <Route
          path="/meditation"
          element={<PageWrapper direction="left"><MeditationPage /></PageWrapper>}
        />
        <Route
          path="/rsi"
          element={<PageWrapper direction="left"><RSIPage /></PageWrapper>}
        />
        <Route
          path="/ponderer"
          element={<PageWrapper direction="left"><PondererPage /></PageWrapper>}
        />
        <Route
          path="/techGym"
          element={<PageWrapper direction="left"><TechGymPage /></PageWrapper>}
        />
        <Route
          path="/dream-machine"
          element={<PageWrapper direction="left"><DreamPage /></PageWrapper>}
        />
        <Route
          path="/ucat"
          element={<PageWrapper direction="left"><UCatPage /></PageWrapper>}
        />
        <Route
          path="/sound"
          element={<PageWrapper direction="left"><SoundPage /></PageWrapper>}
        />
        <Route
          path="/neuro"
          element={<PageWrapper direction="left"><NeuroPage /></PageWrapper>}
        />
        <Route
          path="/space-breathwork"
          element={<MeditationApp />}
        />
        <Route
          path="/escapevelocity"
          element={<PageWrapper direction="left"><EscapeVelocity /></PageWrapper>}
        />
        <Route
          path="/work-with-us"
          element={<PageWrapper direction="left"><WorkWithUsPage /></PageWrapper>}
        />
        <Route
          path="/so-what-now-what"
          element={<PageWrapper direction="left"><SoWhatPage /></PageWrapper>}
        />
      </Routes>
    </AnimatePresence>
  );
}

function MainPage() {
  return (
    <div>
      <Intro />
      <NewProj />
      <div id="media"><MediaSection /></div>
      <div id="contact"><ContactSection /></div>
    </div>
  );
}

function Intro() {
  return (
    <div className="intro-section">
      <img
        src={`${process.env.PUBLIC_URL}/img/goblogo1.png`}
        alt="Neurogoblin Studios"
        className="profile-img"
      />
      <div className="intro-copy">
        <p className="intro-text">
          Neurogoblin Studios builds VR/XR experiences, interactive installations, and embedded systems
          for clients across art, health, education, and games. We make things that blur the line between
          physical and digital and help users expand the limits of their creative expression through technology.
        </p>
        <Link to="/work-with-us" className="wwu-cta">Work With Us →</Link>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <NewHeader /> {/* ✅ Sticky header */}
      <AnimatedRoutes />
    </Router>
  );
}
